import React, { Component } from "react"
import { withStyles } from "@material-ui/core"

import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ABNPriceLocationRisk extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  ABNPriceLocationRiskState: this.props.ABNPriceLocationRisk,
                  selectedLocation: {
                        value: this.props.ABNPriceLocationRisk.ABN_price_location_risk_location_risk_id,
                        label: this.props.ABNPriceLocationRisk.ABN_location_risk_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }
      componentDidMount() {
            this.getoptionLocationRisk()
      }

      getoptionLocationRisk = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].ABN_location_risk_id, label: arr.data[k].ABN_location_risk_name })
                              }
                              self.setState({ optionLocationRisk: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_location_risk")
            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedLocation) => {
            var temparray = this.state.ABNPriceLocationRiskState
            temparray.ABN_price_location_risk_location_risk_id = selectedLocation.value
            this.setState({ selectedLocation: selectedLocation, ABNPriceLocationRiskState: temparray })
      }

      handleChangeDeathRate = (event) => {
            var temparray = this.state.ABNPriceLocationRiskState
            temparray.ABN_price_location_risk_death_rate = event
            this.setState({ ABNPriceLocationRiskState: temparray })
      }
      handleChangeCureRate = (event) => {
            var temparray = this.state.ABNPriceLocationRiskState
            temparray.ABN_price_location_risk_cure_rate = event
            this.setState({ ABNPriceLocationRiskState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { ABNPriceLocationRiskState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_location")
            fd.append("ABN_price_location_risk_id", ABNPriceLocationRiskState.ABN_price_location_risk_id)
            fd.append("ABN_price_location_risk_death_rate", ABNPriceLocationRiskState.ABN_price_location_risk_death_rate)
            fd.append("ABN_price_location_risk_cure_rate", ABNPriceLocationRiskState.ABN_price_location_risk_cure_rate)

            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { ABNPriceLocationRiskState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_location")
            fd.append("ABN_price_location_risk_id", ABNPriceLocationRiskState.ABN_price_location_risk_id)

            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionLocationRisk, snackMode, snackstr, showSnack, visible, selectedLocation, ABNPriceLocationRiskState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={4}>
                                    <div>
                                          <label className="on"> ریسک موقعیت مکانی</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"ریسک موقعیت مکانی"}
                                                value={selectedLocation}
                                                onChange={this.handleInstalmentMode}
                                                options={optionLocationRisk}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={3}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="درصد نرخ فوت"
                                          handleInputt={this.handleChangeDeathRate}
                                          value={ABNPriceLocationRiskState.ABN_price_location_risk_death_rate}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <FloatingLabelInput
                                        type="percent"
                                        placeholder="درصد نرخ پزشکی"
                                        handleInputt={this.handleChangeCureRate}
                                        value={ABNPriceLocationRiskState.ABN_price_location_risk_cure_rate}
                                    />
                              </Grid>
                              <Grid item xs={2}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ABNPriceLocationRisk)
